import React, { useEffect, useState } from "react";
import { isNativeApp, getPlatform } from "@/lib/nativeBridge";

/** Hidden on-device diagnostic (tap the login logo 7×). Shows exactly
 * what this binary reports for native-login plumbing — no logs needed. */
export default function NativeDiagPanel() {
  const [rows, setRows] = useState([["Collecting…", ""]]);

  useEffect(() => {
    (async () => {
      const out = [];
      out.push(["Native shell", isNativeApp() ? "yes" : "NO — web build"]);
      out.push(["Platform", getPlatform()]);
      try {
        const { App } = await import("@capacitor/app");
        const info = await App.getInfo();
        out.push(["Binary version", `${info.version} (build ${info.build})`]);
      } catch {
        out.push(["Binary version", "app plugin unavailable"]);
      }
      try {
        const { BiometricAuth } = await import("@aparajita/capacitor-biometric-auth");
        const b = await BiometricAuth.checkBiometry();
        out.push(["Biometric plugin", "loaded"]);
        out.push(["Biometry available", b.isAvailable ? `yes (${b.biometryType})` : `NO — ${b.reason || "not enrolled"}`]);
      } catch (e) {
        out.push(["Biometric plugin", `MISSING — ${e?.message || "import failed"}`]);
      }
      try {
        const { SecureStoragePlugin } = await import("capacitor-secure-storage-plugin");
        try {
          const r = await SecureStoragePlugin.get({ key: "ak9_bio_token" });
          out.push(["Saved Face ID session", r?.value ? "yes" : "no"]);
        } catch {
          out.push(["Saved Face ID session", "no (log in once to create it)"]);
        }
      } catch (e) {
        out.push(["Keychain plugin", `MISSING — ${e?.message || "import failed"}`]);
      }
      try {
        await import("@capgo/capacitor-social-login");
        out.push(["Google plugin", "loaded"]);
      } catch {
        out.push(["Google plugin", "MISSING"]);
      }
      setRows(out);
    })();
  }, []);

  return (
    <div className="mt-4 rounded-lg border border-[#E5E5E5] bg-[#0E0E0E] text-[#E8E8E8] p-3 text-left" data-testid="native-diag-panel">
      <p className="text-[10px] uppercase tracking-[0.2em] text-gold font-bold mb-2">Device diagnostic</p>
      <dl className="space-y-1">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between gap-3 text-[11.5px] font-mono">
            <dt className="text-[#9A9A9A]">{k}</dt>
            <dd className={/MISSING|NO /.test(v) ? "text-[#FF6B6B] text-right" : "text-right"}>{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
